<template>
	<scroll>
		<div class="result">
			<div class="logo-img">
				<img src="../assets/images/logo.svg" alt />
			</div>
			<div class="kv">
				<img src="../assets/images/kv.jpg" alt />
			</div>
			<div class="text">
				<div class="title">{{ projectName }}</div>
				<!-- <div class="title">
          <img src="../assets/images/title.svg" />
        </div> -->
				<!-- <div class="title">
					<img src="../assets/images/title.png" />
				</div> -->
				<router-view></router-view>
			</div>
		</div>
	</scroll>
</template>
<script>
import Scroll from '@/components/bscroll/bscroll'
export default {
	components: {
		Scroll,
	},
	mounted() {
		document.querySelector('#app').style.height = '100%'
	},
}
</script>

<style lang="stylus" scoped>
.result
  padding-top 32px
  min-height 100%
  display flex
  flex-direction column
  box-sizing border-box
  img
    max-width 100%
  .logo-img
    width 150px
    margin 0 auto 32px
  .kv
    img
      width 100%
  .text
    flex 1
    display flex
    flex-direction column
    justify-content center
    align-items center
    min-height 120px
    .title
      font-size 24px
      line-height 24px
      text-align center
      white-space nowrap
      margin-bottom 14px
      letter-spacing 1px
      font-family PingFangSC-Medium, 'PingFangH'
      img
        width: 273px
        margin: 0 auto;
</style>
